import { Component, h, Host, Prop, Listen, State } from '@stencil/core';

/**
 * Event detail page of kubinaut.
 */

@Component({
  tag: 'kn-page-detail',
  // styleUrl: 'kn-page-detail.scss'
})
export class KnPageDetail {
  /**
   * The link back.
   */
  @Prop() linkBack: string;

  /**
   * The edit link.
   */
  @Prop() linkEdit: string;

  /**
   * The admin link.
   */
  @Prop() linkAdmin: string;

  @Prop() linkCrop: string;

  @State() breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  /** @internal */
  @Listen('hyloBreakpointChanged', { target: 'window' })
  onHyloBreakpointChanged(event: CustomEvent) {
    this.breakpoint = event.detail;
    // FIXME
    // if (event.detail == 'xs' || event.detail == 'sm') document.querySelector('kubinaut-root').hideHeader = true;
    // else document.querySelector('kubinaut-root').hideHeader = false;
  }

  /** @internal */
  componentWillLoad() {
    const breakpoint = document.querySelector('hylo-breakpoint-listener').breakpoint;
    if (breakpoint) this.breakpoint = breakpoint;
    // FIXME
    // if (breakpoint == 'xs' || breakpoint == 'sm') document.querySelector('kubinaut-root').hideHeader = true;
  }

  /** @internal */
  render() {
    return (
      <Host class="tw-block tw-pt-22 md:tw-pt-40">
        <hylo-page-default>
          <hylo-page-width class="tw-grid tw-grid-cols-1 tw-grid-rows-[400px_auto_1fr] md:tw-grid-cols-[1fr_280px] md:tw-grid-rows-[280px_1fr] md:tw-gap-x-8">
            <div id="imageContainer" class="tw-relative tw-mx-hylo-page-padding-n tw-mb-8 md:tw-mx-0 md:tw-mb-0">
              <slot name="image" />

              {!!this.linkBack && (
                <hylo-router-link
                  class="hylo-primary tw-absolute tw-left-4 tw-top-4 md:!tw-hidden"
                  href={this.linkBack}
                  linkLabel="Zurück zur Übersicht"
                >
                  Zurück zur Übersicht
                  <hylo-accessibility-focus></hylo-accessibility-focus>
                </hylo-router-link>
              )}

              {!!this.linkCrop && (
                <hylo-router-link
                  href={this.linkCrop}
                  class="hylo-button hylo-tertiary tw-absolute tw-right-4 tw-top-4 tw-hidden md:tw-block"
                  link-label="Wechsel zur Seite Bildausschnitt bearbeiten."
                >
                  <hylo-icon-crop height="20" color="currentColor" />
                </hylo-router-link>
              )}
            </div>

            <div id="main" class="tw-mb-15 md:tw-row-span-full md:tw-row-start-1 md:tw-mb-0 md:tw-max-w-prose">
              <div class="tw-hidden md:tw-mb-4 md:tw-flex md:tw-items-center md:tw-justify-start md:tw-gap-2">
                {this.linkEdit && (
                  <hylo-router-link
                    href={this.linkEdit}
                    linkLabel="Eintrag bearbeiten."
                    class="hylo-button hylo-primary"
                    contentClass="tw-flex tw-items-center tw-gap-1"
                  >
                    <hylo-icon-edit height={13} color="currentColor" />
                    Bearbeiten
                    <hylo-accessibility-focus></hylo-accessibility-focus>
                  </hylo-router-link>
                )}
                {this.linkAdmin && (
                  <hylo-router-link
                    href={this.linkAdmin}
                    target="_blank"
                    linkLabel="Eintrag als Admin im CMS editieren. Öffnet einen neuen Tab."
                    class="hylo-button hylo-primary"
                  >
                    Admin
                    <hylo-accessibility-focus></hylo-accessibility-focus>
                  </hylo-router-link>
                )}
              </div>

              <div class="tw-flex tw-flex-col tw-gap-12">
                <slot />
              </div>
            </div>
            <div id="sidebar" class="md:tw-col-start-2 md:tw-mt-5">
              <hylo-sr-only>
                <h2>Zusammenfassende Informationen.</h2>
              </hylo-sr-only>

              <div class="[&>div]:tw-flex [&>div]:tw-flex-col [&>div]:tw-gap-5">
                <slot name="supplement" />
              </div>

              <hylo-sr-only>Kategorien beziehungsweise Filter ende.</hylo-sr-only>
            </div>
          </hylo-page-width>

          {/* <div class="md:tw-hidden tw-relative">

          <slot name="image-mobile" />
          
          {this.linkBack && (
            <hylo-router-link
              class="hylo-primary tw-absolute tw-left-8 tw-top-8"
              href={this.linkBack}
              linkLabel="Zurück zur Übersicht"
            >
              Zurück zur Übersicht
              <hylo-accessibility-focus></hylo-accessibility-focus>
            </hylo-router-link>
          )}
        </div> */}

          {/* REVIEW: Do I include those buttons? */}
          {/* 
          {(this.linkEdit || this.linkAdmin) && (
          <div class="tw-">
            {this.linkEdit && (
              <hylo-router-link href={this.linkEdit} linkLabel="Eintrag bearbeiten." class="button black">
                <hylo-icon-edit height={13} color="currentColor" />
                Bearbeiten
                <hylo-accessibility-focus></hylo-accessibility-focus>
              </hylo-router-link>
            )}
            {this.linkAdmin && (
              <hylo-router-link
                href={this.linkAdmin}
                target="_blank"
                linkLabel="Eintrag als Admin im CMS editieren. Öffnet einen neuen Tab."
                class="button red"
              >
                Admin
                <hylo-accessibility-focus></hylo-accessibility-focus>
              </hylo-router-link>
            )}
          </div>
          )} 
          */}

          <hylo-page-width class="tw-hidden md:tw-mt-24 md:tw-block">
            <slot name="gallery" />
          </hylo-page-width>

          <hylo-page-width class="tw-mt-15 tw-space-y-15 md:tw-mt-24 md:tw-space-y-24">
            <slot name="bottom" />
          </hylo-page-width>
        </hylo-page-default>
      </Host>
    );
  }
}
